var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"rt",staticClass:"rich-text",domProps:{"innerHTML":_vm._s(_vm.content)}}),_c('a-drawer',{attrs:{"title":"参考文献","placement":"right","width":"300px","closable":true,"visible":_vm.visible},on:{"close":function($event){_vm.visible = false}}},[_c('div',{staticClass:"about",domProps:{"innerHTML":_vm._s(_vm.activeAbout)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }